import React from 'react';
import { Result, Button, message } from 'antd';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { bindEmail } from '@/api/Dialogs/signUpDlg';

function BindEmail() {
    useEffect(() => {
        emitBind();
    }, []);

    const history = useHistory();
    const location = useLocation();
    const SEARCH = new URLSearchParams(location.search);
    const code = SEARCH.get('code');
    const email = SEARCH.get('email');

    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoad, setisLoad] = useState(false);
    const [seconds, setSeconds] = useState(3);
    const interval = useRef();

    function emitBind() {
        const hideMsg = message.loading(intl.get('userCenter.waiting'), 0);
        bindEmail({ code, email })
            .then(() => {
                interval.current = setInterval(() => {
                    setIsSuccess(true);
                    setSeconds(prev => {
                        const next = --prev;
                        if (!next) {
                            clearInterval(interval.current);
                            interval.current = null;
                            history.push('/home-page');
                        }
                        return next;
                    });
                }, 1_000);
            })
            .catch(() => {
                setIsSuccess(false);
            })
            .finally(() => {
                setisLoad(true);
                hideMsg();
            });
    }

    return (
        isLoad && (
            <Result
                status={isSuccess ? 'success' : 'error'}
                title={isSuccess ? '邮箱绑定成功!' : '邮箱绑定失败!'}
                subTitle={
                    isSuccess ? (
                        <div>
                            {intl.get(
                                'userCenter.loginAndRetrievePasswordByEmail'
                            )}
                            <span className="native-link">{seconds}</span>
                            {intl.get('userCenter.countDownTarget', {
                                seconds: '',
                            })}
                        </div>
                    ) : (
                        ''
                    )
                }
                extra={[
                    <Link to={'/home-page'}>
                        <Button type="primary">{intl.get('pages.home')}</Button>
                    </Link>,
                ]}
            />
        )
    );
}

export default BindEmail;
